import React, { useEffect, useState } from "react";
import Banner from "./Banner";
import Footer from "./Footer";
import Nav from "./Nav";
import QuickView from "./QuickView";
import Row from "./Row";
import { useAuth } from "../context/AuthContext";
import { fetchHomeFeed } from "../services/streamApi";

function StreamingHome() {
  const { user } = useAuth();
  const [feed, setFeed] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedTitle, setSelectedTitle] = useState(null);

  useEffect(() => {
    let active = true;

    async function loadHomeFeed() {
      try {
        setLoading(true);
        const data = await fetchHomeFeed(user?.userId);
        if (!active) return;
        setFeed(data);
      } catch (error) {
        console.error("Erreur chargement accueil:", error);
      } finally {
        if (active) setLoading(false);
      }
    }

    loadHomeFeed();
    return () => {
      active = false;
    };
  }, [user?.userId]);

  return (
    <div className="app-shell">
      <Nav />
      <Banner
        featuredItem={feed?.featured}
        featuredItems={feed?.featuredItems}
        onMoreInfo={setSelectedTitle}
        eyebrow="Tendances du moment"
        isLoading={loading}
      />

      <main className="browse-page">
        <section className="browse-page__stats">
          <div className="browse-page__stat">
            <span className="browse-page__statValue">+{feed?.meta?.totalTitles || 0}</span>
            <span className="browse-page__statLabel">Titres</span>
          </div>
          <div className="browse-page__stat">
            <span className="browse-page__statValue">+{feed?.meta?.films || 0}</span>
            <span className="browse-page__statLabel">Films</span>
          </div>
          <div className="browse-page__stat">
            <span className="browse-page__statValue">+{feed?.meta?.series || 0}</span>
            <span className="browse-page__statLabel">Series</span>
          </div>
          <div className="browse-page__stat">
            <span className="browse-page__statValue">+{feed?.meta?.documentaires || 0}</span>
            <span className="browse-page__statLabel">Docs</span>
          </div>
        </section>

        {loading ? (
          <section className="page-placeholder">
            <div className="page-placeholder__row" />
            <div className="page-placeholder__row" />
            <div className="page-placeholder__row" />
          </section>
        ) : (
          feed?.rows?.map((row) => (
            <Row
              key={row.id}
              title={row.title}
              subtitle={row.subtitle}
              items={row.items}
              onMoreInfo={setSelectedTitle}
            />
          ))
        )}
      </main>

      <Footer />
      <QuickView movie={selectedTitle} popup={() => setSelectedTitle(null)} popupStatut={Boolean(selectedTitle)} />
    </div>
  );
}

export default StreamingHome;
